module.exports = __webpack_public_path__ + "04_face.85da6716.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/04_face.png
// module id = Y+rG
// module chunks = 0